import { z } from 'zod';
import { ActionSchema } from '../actions';

export const TextBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('text'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    text: z.string().max(2000),
    size: z.enum(['sm', 'md', 'lg', 'xl']),
    align: z.enum(['left', 'center', 'right']),
    weight: z.enum(['normal', 'bold'])
  })
});